import MESSAGES from 'core/data-model/constants/bi-messages'

const HALF_MARGIN = -4

export const basicPlanConditionGIOSection = () => ({
  stack: [
    {
      text: MESSAGES.CONDITION_TITLE,
      style: 'title',
      pageBreak: 'before',
    },
    {
      text: MESSAGES.COMPLETED_TITLE,
      style: 'sub-title',
    },
    {
      text: MESSAGES.COMPLETED_MESSAGE_ONE,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.COMPLETED_MESSAGE_TWO,
      style: 'textRow',
    },
    {
      text: MESSAGES.COMPLETED_MESSAGE_THREE,
      style: 'textRow',
    },
    {
      text: MESSAGES.NO_COVER_TITLE,
      style: 'sub-title',
    },
    {
      ol: [
        [
          {
            text: MESSAGES.GIO_PRODUCT_NO_COVER_MESSAGE_BULLET_ONE_ONE,
            style: 'textRow',
          },
          {
            text: MESSAGES.NO_COVER_MESSAGE_BULLET_ONE_TWO,
            style: 'textRow',
          },
        ],
        [
          {
            text: MESSAGES.GIO_PRODUCT_NO_COVER_MESSAGE_BULLET_TWO,
            style: 'textRow',
          },
        ],
        [
          {
            text: MESSAGES.NO_COVER_MESSAGE_BULLET_THREE,
            style: 'textRow',
          },
        ],
      ],
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.CLAIM_TITLE,
      style: 'sub-title',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.CLAIM_MESSAGE,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.FREELOOK_TITLE,
      style: 'sub-title',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.FREELOOK_MESSAGE,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.IMPACT_INSURED_TITLE,
      style: 'sub-title',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.IMPACT_INSURED_MESSAGE,
      style: 'textRow',
    },
    {
      text: MESSAGES.GIO_PRODUCT_POLICY_VALUE_BENEFIT_TITLE,
      style: 'sub-title',
      marginTop: HALF_MARGIN,
      pageBreak: 'before',
    },
    {
      text: MESSAGES.GIO_PRODUCT_POLICY_VALUE_BENEFIT_BULLET_ONE,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.GIO_PRODUCT_POLICY_VALUE_BENEFIT_BULLET_TWO,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },

    {
      text: MESSAGES.DELIVERY_PERIOD_TITLE,
      style: 'sub-title',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.DELIVERY_PERIOD_MESSAGE,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.CHANNEL_TITLE,
      style: 'sub-title',
      marginTop: HALF_MARGIN,
    },
    {
      text: MESSAGES.CHANNEL_MESSAGE,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
    { text: ' ' },
    {
      text: MESSAGES.ORDINARY_CHANNEL_MESSAGE_ADDITIONAL,
      style: 'textRow',
      marginTop: HALF_MARGIN,
    },
  ],
  style: 'groupRow',
})
